import { createRouter, createWebHistory } from "vue-router";
import Points from "../views/1-Points.vue";

const routes = [
  {
    path: "/",
    name: "points",
    component: Points,
  },
  {
    path: "/points",
    name: "Points",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "points" */ "../views/1-Points.vue"),
  },
  {
    path: "/lines",
    name: "Lines",
    component: () =>
      import(/* webpackChunkName: "lines" */ "../views/2-Lines.vue"),
  },
  {
    path: "/polygons",
    name: "Polygons",
    component: () =>
      import(/* webpackChunkName: "polygons" */ "../views/3-Polygons.vue"),
  },
  {
    path: "/hexagons",
    name: "Hexagons",
    component: () =>
      import(/* webpackChunkName: "hexagons" */ "../views/4-Hexagons.vue"),
  },
  {
    path: "/open-street-map",
    name: "Open Street Map",
    component: () =>
      import(
        /* webpackChunkName: "open-street-map" */ "../views/5-OpenStreetMap.vue"
      ),
  },
  {
    path: "/red",
    name: "Red",
    component: () => import(/* webpackChunkName: "red" */ "../views/6-Red.vue"),
  },
  {
    path: "/green",
    name: "Green",
    component: () =>
      import(/* webpackChunkName: "green" */ "../views/7-Green.vue"),
  },
  {
    path: "/blue",
    name: "Blue",
    component: () =>
      import(/* webpackChunkName: "blue" */ "../views/8-Blue.vue"),
  },
  {
    path: "/monochrome",
    name: "Monochrome",
    component: () =>
      import(/* webpackChunkName: "monochrome" */ "../views/9-Monochrome.vue"),
  },
  {
    path: "/raster",
    name: "Raster",
    component: () =>
      import(/* webpackChunkName: "raster" */ "../views/10-Raster.vue"),
  },
  {
    path: "/3D",
    name: "3D",
    component: () => import(/* webpackChunkName: "3d" */ "../views/11-3D.vue"),
  },
  {
    path: "/population",
    name: "Population",
    component: () =>
      import(/* webpackChunkName: "population" */ "../views/12-Population.vue"),
  },
  {
    path: "/natural-earth",
    name: "Natural Earth",
    component: () =>
      import(
        /* webpackChunkName: "natural-earth" */ "../views/13-NaturalEarth.vue"
      ),
  },
  // {
  //   path: "/new-tool",
  //   name: "New Tool",
  //   component: () =>
  //     import(/* webpackChunkName: "new-tool" */ "../views/14-NewTool.vue")
  // },
  // {
  //   path: "/nae-computer",
  //   name: "Nae Computer",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "nae-computer" */ "../views/15-NaeComputer.vue"
  //     )
  // },
  // {
  //   path: "/urban-rural",
  //   name: "Rural/Urban",
  //   component: () =>
  //     import(/* webpackChunkName: "rural-urban" */ "../views/16-UrbanRural.vue")
  // },
  // {
  //   path: "/land",
  //   name: "Land",
  //   component: () =>
  //     import(/* webpackChunkName: "land" */ "../views/17-Land.vue")
  // },
  // {
  //   path: "/water",
  //   name: "Water",
  //   component: () =>
  //     import(/* webpackChunkName: "water" */ "../views/18-Water.vue")
  // },
  // {
  //   path: "/islands",
  //   name: "Islands",
  //   component: () =>
  //     import(/* webpackChunkName: "islands" */ "../views/19-Islands.vue")
  // },
  // {
  //   path: "/movement",
  //   name: "Movement",
  //   component: () =>
  //     import(/* webpackChunkName: "movement" */ "../views/20-Movement.vue")
  // },
  // {
  //   path: "/elevation",
  //   name: "Elevation",
  //   component: () =>
  //     import(/* webpackChunkName: "elevation" */ "../views/21-Elevation.vue")
  // },
  // {
  //   path: "/boundaries",
  //   name: "Boundaries",
  //   component: () =>
  //     import(/* webpackChunkName: "boundaries" */ "../views/22-Boundaries.vue")
  // },
  // {
  //   path: "/ghsl",
  //   name: "GHSL",
  //   component: () =>
  //     import(/* webpackChunkName: "ghsl" */ "../views/23-GHSL.vue")
  // },
  // {
  //   path: "/historical",
  //   name: "Historical",
  //   component: () =>
  //     import(/* webpackChunkName: "historical" */ "../views/24-Historical.vue")
  // },
  // {
  //   path: "/interactive",
  //   name: "Interactive",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "interactive" */ "../views/25-Interactive.vue"
  //     )
  // },
  // {
  //   path: "/choropleth",
  //   name: "Choropleth",
  //   component: () =>
  //     import(/* webpackChunkName: "choropleth" */ "../views/26-Choropleth.vue")
  // },
  // {
  //   path: "/heatmap",
  //   name: "Heatmap",
  //   component: () =>
  //     import(/* webpackChunkName: "heatmap" */ "../views/27-Heatmap.vue")
  // },
  // {
  //   path: "/flat-earth",
  //   name: "Flat Earth",
  //   component: () =>
  //     import(/* webpackChunkName: "flat-earth" */ "../views/28-FlatEarth.vue")
  // },
  // {
  //   path: "/null",
  //   name: "NULL",
  //   component: () =>
  //     import(/* webpackChunkName: "null" */ "../views/29-Null.vue")
  // },
  // {
  //   path: "/metamapping",
  //   name: "Metamapping",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "metamapping" */ "../views/30-Metamapping.vue"
  //     )
  // }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
